import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { companiesService } from '../services/companies';
import { useFetch } from '../hooks/useFetch';
import DataTable from '../components/DataTable';
import Spinner from '../components/Spinner';
import StatusMessage from '../components/StatusMessage';
import CreateCompanyModal from './companies/CreateCompanyModal';
import type { AdminCompany, AdminCompanyCreateResult } from '../types';

const Badge = ({ ok, text }: { ok: boolean; text: string }) => (
  <span className={`px-2 py-0.5 rounded text-xs ${ok ? 'bg-green-100 text-green-700' : 'bg-gray-200 text-gray-600'}`}>{text}</span>
);

const Companies = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('');
  const { data, loading, error } = useFetch(() => companiesService.list({ search, status }), [search, status]);
  const [showCreate, setShowCreate] = useState(false);

  const onCreated = (result: AdminCompanyCreateResult, adminEmail: string) => {
    setShowCreate(false);
    const flash = `Perusahaan dibuat. Email onboarding ${result.email_sent ? 'terkirim' : 'GAGAL terkirim'} ke ${adminEmail}.`;
    navigate(`/companies/${result.id}`, { state: { flash } });
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Companies</h1>
        <button onClick={() => setShowCreate(true)} className="bg-primary-600 text-white rounded px-4 py-2 text-sm">Buat Perusahaan</button>
      </div>
      <div className="flex gap-2">
        <input className="border rounded px-3 py-2 text-sm" placeholder="Search…" value={search} onChange={(e) => setSearch(e.target.value)} />
        <select className="border rounded px-3 py-2 text-sm" value={status} onChange={(e) => setStatus(e.target.value)}>
          <option value="">All</option><option value="active">Active</option><option value="expired">Expired</option><option value="suspended">Suspended</option>
        </select>
      </div>
      <StatusMessage error={error} />
      {loading ? <Spinner /> : <DataTable<AdminCompany>
        columns={[
          { key: 'company_name', header: 'Company' },
          { key: 'employee_count', header: 'Employees' },
          { key: 'subscription_status', header: 'Subscription', render: (r) => <Badge ok={r.subscription_status === 'active'} text={r.subscription_status} /> },
          { key: 'is_suspended', header: 'Status', render: (r) => <Badge ok={!r.is_suspended} text={r.is_suspended ? 'Suspended' : 'OK'} /> },
          { key: 'open', header: '', render: (r) => <button className="text-primary-600 text-sm" onClick={() => navigate(`/companies/${r.id}`)}>View</button> },
        ]}
        rows={data ?? []} />}
      <CreateCompanyModal open={showCreate} onClose={() => setShowCreate(false)} onCreated={onCreated} />
    </div>
  );
};
export default Companies;
